import clsx from 'clsx'
import React, {useEffect, useRef, useState} from 'react'
import {Container, Row, Col, Collapse, Form, Pagination} from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'
import {Link} from 'react-router-dom'
import {NoDataPage} from '../../resources/components/NoDataPage'
import {useIntl} from 'react-intl'
import FilterIcon from '../../../../media/resources/icons/ic-filter.svg'
import FilterIconFunnel from '../../../../media/resources/icons/filterIcon.svg'
import DropdownIcon from '../../../../media/shared-access/ic-dropdown.svg'
import {toast} from 'react-toastify'
import StartupFullWidthCard from './StartupFullWidthCard'
import {getAllStartupShowcase} from '../core/_requests'
import {useAuth} from '../../auth'

const OtherStartups = () => {
  const categories = [
    {label: 'All', value: 'All'},
    {label: 'NDA', value: 'NDA'},
    {label: 'Business', value: 'Business'},
    {label: 'Productivity', value: 'Productivity'},
    {label: 'Finance', value: 'Finance'},
    {label: 'Legal', value: 'Legal'},
    {label: 'Start Ups', value: 'Start Ups'},
    {label: 'Agreements', value: 'Agreements'},
  ]
  const sort_by = [
    {label: 'All', value: 'All'},
    {label: 'Featured', value: 'Featured'},
    {label: 'Newest', value: 'Newest'},
    {label: 'Most Voted', value: 'Most Voted'},
  ]
  const industries = [
    {label: 'All', value: 'All'},
    {label: 'Technology', value: 'Technology'},
    {label: 'Web 3', value: 'Web 3'},
    {label: 'Finance', value: 'Finance'},
    {label: 'Education', value: 'Education'},
    {label: 'Healthcare', value: 'Healthcare'},
  ]
  const location = [
    {label: 'All', value: 'All'},
    {label: 'India', value: 'India'},
    {label: 'United States', value: 'United States'},
    {label: 'UK', value: 'UK'},
    {label: 'Germany', value: 'Germany'},
    {label: 'France', value: 'France'},
  ]

  const {formatMessage} = useIntl()
  const [showCategories, setShowCategories] = useState(false)
  const [sortOpen, setSortOpen] = useState(false)
  const [industriesOpen, setIndustriesOpen] = useState(false)
  const [locationOpen, setLocationOpen] = useState(false)
  const [search, setSearch] = useState<string>('')
  //   const [AllResourcesData, setAllResourcesData] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [startupPerPage, setStartupPerPage] = useState<number>(10)
  const [category, setCategory] = useState<string>(categories.map((cat) => cat.value).join(', ')) //eslint-disable-line
  const [sortBy, setSortBy] = useState<string>('') //eslint-disable-line
  const [sortOrder, setSortOrder] = useState<string>('ASC')
  const [count, setCount] = useState<number>(0)
  const [pageNumbers, setPageNumbers] = useState<number[]>([])
  const [AllStartupShowcases, setAllStartupShowcases] = useState<any[]>([])
  const {companyId} = useAuth()

  const [selectedSort_by, setSelectedSort_by] = useState<string[]>(sort_by.map((srt) => srt.value))
  const [selectedIndustries, setSelectedIndustries] = useState<string[]>(
    industries.map((ind) => ind.value)
  )
  const [selectedLocation, setSelectedLocation] = useState<string[]>(
    location.map((loc) => loc.value)
  )

  //   const getAllResources = async () => {
  //     try {
  //       // setLoading(true)

  //       // Static data instead of fetching from API
  //       const staticData = {
  //         success: true,
  //         data: {
  //           totalRecords: 3, // example total records
  //           resources: [
  //             {
  //               id: 1,
  //               title: 'FounderCrate 1',
  //               subTitle: 'Fundraising Process Made Easy',
  //               description:
  //                 'Fundraising Process Made EasyLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu...',
  //               badge: 'Technology',
  //             },
  //             {
  //               id: 2,
  //               title: 'FounderCrate 2',
  //               subTitle: 'Fundraising Process Made Easy',
  //               description:
  //                 'Fundraising Process Made EasyLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu...',
  //               badge: 'Technology',
  //             },
  //             {
  //               id: 3,
  //               title: 'FounderCrate 3',
  //               subTitle: 'Fundraising Process Made Easy',
  //               description:
  //                 'Fundraising Process Made EasyLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu...',
  //               badge: 'Technology',
  //             },
  //           ],
  //         },
  //         errors: [],
  //       }

  //       const {success, data, errors} = staticData

  //       if (success) {
  //         setCount(data.totalRecords)
  //         setAllResourcesData(data.resources)
  //       } else {
  //         errors?.forEach((error: string) => {
  //           toast.error(formatMessage({id: error}))
  //         })
  //       }
  //     } catch (err) {
  //       console.error('Error fetching resources:', err)
  //       toast.error(formatMessage({id: 'Failed to fetch resources'}))
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  const getAllStartupShowcases = async () => {
    try {
      setLoading(true)
      const {
        data: {success, data, errors},
      } = await getAllStartupShowcase(companyId!)
      if (success) {
        setAllStartupShowcases(data.startupShowcases)
        setCount(data.totalRecords)
        setCurrentPage(data.currentPage)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const dropdownRef = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleStartupPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setStartupPerPage(Number(event.target.value))
    setCurrentPage(1)
  }

  useEffect(() => {
    const calculatePageNumbers = () => {
      const pages = []
      for (let i = 1; i <= Math.ceil(count / startupPerPage); i++) {
        pages.push(i)
      }
      setPageNumbers(pages)
    }

    calculatePageNumbers()
  }, [count, startupPerPage])

  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: 'sort_by' | 'industry' | 'location'
  ) => {
    const selectedValue = event.target.value
    let updatedSelection: string[]

    // Determine which selection array to update based on the type
    switch (type) {
      case 'sort_by':
        updatedSelection = [...selectedSort_by]
        break
      case 'industry':
        updatedSelection = [...selectedIndustries]
        break
      case 'location':
        updatedSelection = [...selectedLocation]
        break
      default:
        return // Early return if the type is not valid
    }

    // Handle 'All' selection
    if (selectedValue === 'All') {
      if (event.target.checked) {
        updatedSelection = type === 'sort_by' ? sort_by.map((s) => s.value) : [] // Adjust based on the type
      } else {
        updatedSelection = [] // Clear selection if 'All' is unchecked
      }
    } else {
      // Add or remove selected value
      if (event.target.checked) {
        updatedSelection.push(selectedValue)
      } else {
        updatedSelection = updatedSelection.filter((item) => item !== selectedValue)
      }
    }

    // Update state based on the type
    if (type === 'sort_by') {
      setSelectedSort_by(updatedSelection)
    } else if (type === 'industry') {
      setSelectedIndustries(updatedSelection)
    } else if (type === 'location') {
      setSelectedLocation(updatedSelection)
    }

    // Update category display string if needed
    setCategory(updatedSelection.join(', '))
  }

  useEffect(() => {
    if (selectedSort_by.length === categories.length - 1 && !selectedSort_by.includes('All')) {
      setSelectedSort_by([...selectedSort_by, 'All'])
    } else if (selectedSort_by.length !== categories.length && selectedSort_by.includes('All')) {
      setSelectedSort_by(selectedSort_by.filter((cat) => cat !== 'All'))
    }
    setCategory(selectedSort_by.join(', '))
  }, [selectedSort_by]) // eslint-disable-line

  const handleSortOrderChange = (order: string) => {
    setSortBy('voteCount')
    setSortOrder(order)
  }

  useEffect(() => {
    let handler: any
    if (search.length >= 3 || !search) {
      setLoading(true)
      handler = setTimeout(() => {
        getAllStartupShowcases()
      }, 200)
    }

    return () => {
      clearTimeout(handler)
    }
  }, [search]) // eslint-disable-line

  return (
    <>
      <div className='d-flex justify-content-between align-items-center my-4 gap-md-8 gap-2'>
        <button
          className='d-flex align-items-center btn bg-white gap-2 p-4'
          onClick={() => {
            setShowCategories(!showCategories)
            // setShowSort_by(!showSort_by);
          }}
        >
          <img src={FilterIconFunnel} alt='' />
          <span className='d-none d-sm-block'>{formatMessage({id: 'Filters'})}</span>
        </button>

        <div className='d-flex align-items-center gap-2 w-100 w-md-auto'>
          <input
            type='text'
            className='bg-body form-control ps-4 rounded-2 font-size-13 font-weight-400'
            name='search'
            placeholder={formatMessage({id: 'Search'})}
            data-kt-search-element='input'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <div className='card-toolbar' style={{position: 'relative'}} ref={dropdownRef}>
            <Link
              to='#'
              className='btn bg-white rounded-2 p-3'
              onClick={toggleDropdown}
              aria-expanded={isOpen}
            >
              <img src={FilterIcon} alt='Filter Icon' />
            </Link>
            {isOpen && (
              <div
                className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 bg-white shadow w-200px fw-semibold fs-7 py-2'
                style={{
                  position: 'absolute',
                  top: '110%',
                  right: 0,
                  zIndex: 1000,
                  display: isOpen ? 'block' : 'none',
                }}
              >
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'ASC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('ASC')}
                  >
                    {formatMessage({id: 'Alphabetic (Ascending)'})}
                  </Link>
                </div>
                <div className='menu-item px-2'>
                  <Link
                    to='#'
                    className={`menu-link px-2 ${sortOrder === 'DESC' ? 'text-primary' : ''}`}
                    onClick={() => handleSortOrderChange('DESC')}
                  >
                    {formatMessage({id: 'Alphabetic (Descending)'})}
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Container fluid>
        <Row>
          {showCategories && (
            <Col xs={12} md={3} className='bg-white px-0 rounded-2 h-100'>
              {/* Sort By Section */}
              <div
                onClick={() => setSortOpen(!sortOpen)}
                aria-controls='sort-collapse'
                aria-expanded={sortOpen}
                style={{cursor: 'pointer'}}
              >
                <div className='d-flex justify-content-between align-items-center px-6 py-6'>
                  <h2 className='font-size-14 text-secondry'>{formatMessage({id: 'Sort By'})}</h2>
                  <img src={DropdownIcon} alt='' />
                </div>
              </div>
              <Collapse in={sortOpen}>
                <div id='sort-collapse' className='px-6 h-100'>
                  <Form>
                    {sort_by.map((srt) => (
                      <Form.Check
                        key={srt.value}
                        type='checkbox'
                        label={formatMessage({id: srt.label})}
                        className='mb-4'
                        style={{color: '#383940'}}
                        value={srt.value}
                        checked={selectedSort_by.includes(srt.value)}
                        onChange={(event) => handleCheckboxChange(event, 'sort_by')}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>

              {/* Industries Section */}
              <div
                onClick={() => setIndustriesOpen(!industriesOpen)}
                aria-controls='industries-collapse'
                aria-expanded={industriesOpen}
                style={{cursor: 'pointer'}}
              >
                <div className='d-flex justify-content-between align-items-center px-6 py-6'>
                  <h2 className='font-size-14 text-secondry'>
                    {formatMessage({id: 'Industries'})}
                  </h2>
                  <img src={DropdownIcon} alt='' />
                </div>
              </div>
              <Collapse in={industriesOpen}>
                <div id='industries-collapse' className='px-6 h-100'>
                  <Form>
                    {industries.map((ind) => (
                      <Form.Check
                        key={ind.value}
                        type='checkbox'
                        label={formatMessage({id: ind.label})}
                        className='mb-4'
                        style={{color: '#383940'}}
                        value={ind.value}
                        checked={selectedIndustries.includes(ind.value)}
                        onChange={(event) => handleCheckboxChange(event, 'industry')}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>

              {/* Location Section */}
              <div
                onClick={() => setLocationOpen(!locationOpen)}
                aria-controls='location-collapse'
                aria-expanded={locationOpen}
                style={{cursor: 'pointer'}}
              >
                <div className='d-flex justify-content-between align-items-center px-6 py-6'>
                  <h2 className='font-size-14 text-secondry'>{formatMessage({id: 'Location'})}</h2>
                  <img src={DropdownIcon} alt='' />
                </div>
              </div>
              <Collapse in={locationOpen}>
                <div id='location-collapse' className='px-6 h-100'>
                  <Form>
                    {location.map((loc) => (
                      <Form.Check
                        key={loc.value}
                        type='checkbox'
                        label={formatMessage({id: loc.label})}
                        className='mb-4'
                        style={{color: '#383940'}}
                        value={loc.value}
                        checked={selectedLocation.includes(loc.value)}
                        onChange={(event) => handleCheckboxChange(event, 'location')}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>
            </Col>
          )}
          <Col
            xs={12}
            md={showCategories ? 9 : 12}
            className={clsx('px-0 resource-section-v2', {
              'ps-4': showCategories,
              'ps-0': !showCategories,
            })}
          >
            {loading ? (
              Array(9)
                .fill(null)
                .map((_, index) => (
                  <div className='mb-4 rounded-2' key={index}>
                    <Skeleton
                      height={225}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ))
            ) : (
              <>
                {loading ? (
                  <Skeleton
                    height={225}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                ) : AllStartupShowcases.length === 0 ? (
                  <NoDataPage />
                ) : (
                  <div className='resources-list'>
                    {AllStartupShowcases &&
                      AllStartupShowcases.map((startup: any) => <StartupFullWidthCard startupDetails={startup}/>)}
                  </div>
                )}
              </>
            )}

            {/* Pagination Section */}
            <div
              className={clsx('w-100 d-flex justify-content-between align-items-center px-0 my-8', {
                'd-none': AllStartupShowcases.length === 0,
              })}
            >
              <div className='d-flex gap-2 w-100 align-items-center'>
                <Form.Select
                  aria-label='Default select example'
                  className='px-4 py-3 w-80px'
                  value={startupPerPage}
                  onChange={handleStartupPerPageChange}
                >
                  <option value='10'>{formatMessage({id: '10'})}</option>
                  <option value='20'>{formatMessage({id: '20'})}</option>
                  <option value='50'>{formatMessage({id: '50'})}</option>
                  <option value='100'>{formatMessage({id: '100'})}</option>
                </Form.Select>
                <span className='font-size-13'>
                  {`Showing ${(currentPage - 1) * startupPerPage + 1} to ${Math.min(
                    (currentPage - 1) * startupPerPage + 1 + startupPerPage - 1,
                    count
                  )} of ${count} records`}
                </span>
              </div>
              <Pagination className='w-100 d-flex flex-end'>
                <Pagination.First
                  key='first'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(1)}
                />
                <Pagination.Prev
                  key='prev'
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => p - 1)}
                />
                {pageNumbers.map((number) => (
                  <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => setCurrentPage(number)}
                  >
                    {number}
                  </Pagination.Item>
                ))}
                {pageNumbers.length > 6 && (
                  <>
                    {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                    {currentPage >= pageNumbers.length - 3 && (
                      <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                    )}
                  </>
                )}
                <Pagination.Next
                  key='next'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage((p) => p + 1)}
                />
                <Pagination.Last
                  key='last'
                  disabled={currentPage === pageNumbers.length}
                  onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                />
              </Pagination>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default OtherStartups
